export default __webpack_public_path__ + "static/media/image.yara-technologies-pvt-ltd.86034bd8.png";